/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * EraseIcon
 */
export default class EraseIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M2 21h20a1 1 0 01.117 1.993L22 23H2a1 1 0 01-.117-1.993L2 21h20zM15.03 3.836l.15.138 2.817 2.762a3.305 3.305 0 01.146 4.591l-.138.143-8.412 8.244a1 1 0 01-.572.278L8.89 20l-3.373-.008a1 1 0 01-.6-.201l-.098-.085-2.817-2.761a3.305 3.305 0 01-.146-4.591l.138-.143 8.412-8.245c1.27-1.244 3.294-1.286 4.623-.13zM4.823 12.238l-1.429 1.401a1.302 1.302 0 00-.091 1.769l.1.109 2.526 2.476L8.486 18l1.059-1.039-4.722-4.722zm7.096-6.942l-.112.099-5.555 5.442 4.722 4.722 5.632-5.518a1.302 1.302 0 00.091-1.768l-.1-.109-2.817-2.761a1.423 1.423 0 00-1.86-.107z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

